import { makeCommandFromAttributes } from '../../utils/index.js';
const rosterSendKey = 'J';
export const rosterCommand = ({ cabId } = {}) => {
    return makeCommandFromAttributes([rosterSendKey, cabId]);
};
